import Box from "@mui/material/Box";
import { withGridCellParams } from "ui/widgets/Table/renderers";
import { compactDecimalFormatter } from "util/formaters";

const Boldable = withGridCellParams<string>(({ value }) => (
    <Box
        sx={{
            fontWeight: 'bold'
        }}
    >
        {compactDecimalFormatter(value) || '-'}
    </Box>
));

export default Boldable;
